// extracted by mini-css-extract-plugin
module.exports =  {"root":"OJCkx5YPDZ335KnD_NqQ"};